export default "__VITE_ASSET__c356f0cc__"